import { DeclarativeMapImplementation } from './declarative-map-implementation';
import { inject, InjectionToken, Provider, Type } from '@angular/core';

export const DECLARATIVE_MAP_IMPLEMENTATION = new InjectionToken<DeclarativeMapImplementation>(
  'cue-declarative-map-implementation'
);
export const DECLARATIVE_MAP_IMPLEMENTATION_TYPE = new InjectionToken<Type<DeclarativeMapImplementation>>(
  'cue-declarative-map-implementation-type'
);

export function provideDeclarativeMapImplementationTypeResolver(
  implementationResolver: () => Type<DeclarativeMapImplementation>
): Provider {
  return {
    provide: DECLARATIVE_MAP_IMPLEMENTATION_TYPE,
    useFactory: implementationResolver,
  };
}

export function provideDeclarativeMapImplementation(implementation?: Type<DeclarativeMapImplementation>): Provider {
  return {
    provide: DECLARATIVE_MAP_IMPLEMENTATION,
    useFactory: () => {
      const resolvedImplementation = implementation ?? inject(DECLARATIVE_MAP_IMPLEMENTATION_TYPE, { optional: true });

      if (!resolvedImplementation) {
        throw new Error(
          [
            'Declarative map implementation was not configured.',
            'Provide it on component level using provideDeclarativeMapImplementation(ImplementationClass)',
            'or on application level using provideDeclarativeMapImplementationTypeResolver(() => ImplementationClass).',
          ].join(' ')
        );
      }

      return new resolvedImplementation();
    },
  };
}
